import React from "react";
import Icon, { IconProps } from "./Icon";

export default function Payroll({
  viewBox = "0 0 20 20",
  width = 20,
  height = 20,
  fill = "none",
  color = "currentColor",
  stroke = color,
  ...iconProps
}: IconProps) {
  return (
    <Icon height={height} width={width} fill={fill} {...iconProps} viewBox={viewBox}>
      <path
        d="M14.7918 16.0417H17.8527C18.3372 16.0417 18.7237 15.6284 18.6423 15.1507C18.1994 12.552 16.6827 10.625 14.1668 10.625C13.7951 10.625 13.4452 10.6671 13.1173 10.7471M9.37506 5.83333C9.37506 7.3291 8.1625 8.54167 6.66673 8.54167C5.17096 8.54167 3.9584 7.3291 3.9584 5.83333C3.9584 4.33756 5.17096 3.125 6.66673 3.125C8.1625 3.125 9.37506 4.33756 9.37506 5.83333ZM16.4584 6.25C16.4584 7.51565 15.4324 8.54167 14.1667 8.54167C12.9011 8.54167 11.8751 7.51565 11.8751 6.25C11.8751 4.98435 12.9011 3.95833 14.1667 3.95833C15.4324 3.95833 16.4584 4.98435 16.4584 6.25ZM1.5589 15.984C2.03216 12.9164 3.76437 10.625 6.66673 10.625C9.56909 10.625 11.3013 12.9164 11.7746 15.984C11.8484 16.4625 11.4627 16.875 10.9786 16.875H2.35489C1.87071 16.875 1.48507 16.4625 1.5589 15.984Z"
        stroke={stroke}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}
